import Layout from '@/layout/index.vue'
import stdiframe from '@/views/stdiframe'

const pathList = [
    // 在线询价
    {   
        routerName: 'enquiry',
        pagePath: 'enquiry',
        title: 'enquiry',
        hidden: false,
        stdPagePath: 'stdDashboard',
    },
    // 已保存询价
    {
        routerName: 'savedEnquiryOrder',
        pagePath: 'enquiry/detail',
        title: 'savedEnquiryOrder',
        hidden: false,
        stdPagePath: 'stdEnquiry/detail',
    },
    // 已下单询价
    {
        routerName: 'enquiryOrder',
        pagePath: 'enquiry/order',
        title: 'enquiryOrder',
        hidden: false,
        stdPagePath: 'stdEnquiry/order',
    },
    // 已失效询价
    {
        routerName: 'loseEnquiryOrder',
        pagePath: 'enquiry/lose',
        title: 'loseEnquiryOrder',
        hidden: false,
        stdPagePath: 'stdEnquiry/list',
    },
    // STD运单
    {
        routerName: 'stdWaybillList',
        pagePath: 'waybillList',
        title: 'stdWaybillList',
        hidden: false,
        stdPagePath: 'stdWaybillManagement/waybillList',
    },
    // STD运单详情
    {
        routerName: 'stdWaybillDetail',
        pagePath: 'waybillDetail',
        title: 'stdWaybillDetail',
        hidden: true,
        stdPagePath: 'stdWaybillManagement/waybillDetails',
    },
    // STD运单下单
    {
        routerName: 'stdWaybillOrder',
        pagePath: 'waybillOrder',
        title: 'stdWaybillOrder',
        hidden: true,
        stdPagePath: 'stdWaybillManagement/order',
    },
    // STD账单列表
    {
        routerName: 'stdBill',
        pagePath: 'billList',
        title: 'stdBill',
        hidden: false,
        stdPagePath: 'stdBill/list',
    },
    // 联系方式
    {
        routerName: 'stdContactWay',
        pagePath: 'contactWay',
        title: 'stdContactWay',
        hidden: false,
        stdPagePath: 'stdMyProfile/contactWay',
    },
    // 优惠券
    {
        routerName: 'stdCoupon',
        pagePath: 'coupon',
        title: 'stdCoupon',
        hidden: false,
        stdPagePath: 'stdMyProfile/coupon',
    },
    // 认证
    {
        routerName: 'enterpriseAuth',
        pagePath: 'enterpriseAuth',
        title: 'enterpriseAuth',
        hidden: true,
        stdPagePath: 'stdMyProfile/enterpriseAuth',
    }
]

const routerChildren = pathList.map(i=>{
   return ({
        path: i.pagePath,
        hidden: i.hidden,
        component: stdiframe,
        name: i.routerName,
        meta: {
          title: i.title,
          stdPagePath: i.stdPagePath
        }
      })
})
const stdRouter = {
  path: '/std',
  component: Layout,
  redirect: 'noredirect',
  name: 'std',
  meta: {
    title: 'stdEnquiry',
    icon: 'std-enquiry',
  },
  children: routerChildren
}
export default stdRouter